import { useCompanyCreateAmoTaskToBillMutation } from 'domain/api/graphql/generated';
import { FetchPolicyKeys } from 'domain/api/graphql/types';

const useCompanyCreateAmoTaskToBill = () => {
  const [mutation, mutationResult] = useCompanyCreateAmoTaskToBillMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (companyId: string) => {
    const mutationResult = await mutation({
      variables: {
        input: {
          companyId,
        },
      },
      refetchQueries: ['authCurrentUser'],
    });

    return !!mutationResult.data?.result?.ok;
  };

  return {
    error: mutationResult.error,
    loading: mutationResult.loading,
    called: mutationResult.called,
    request,
  };
};

export default useCompanyCreateAmoTaskToBill;
